<script>
  import { ICONS } from "../js/icons";
  import backend from "../server";

  import ListCampaignV2 from "../lib/components/modals/freebets/first2/ListV2.svelte";
  import PlayersCampaignV2 from "../lib/components/modals/freebets/first2/PlayersV2.svelte";

  export let adapter = {
    providerCode: "first2",
    providerName: "First V2",
    bonusPrefix: "FIRST2_",
    maxDays: 30,
  };
  export let icons = ICONS;

  let showPlayersCampaign = false;
  let playersCampaign = null;
  let listRef;

  const api = {
    listByProvider: async (_provider, params) => {
      return backend.freespin.listFirst2Campaigns(params);
    },
    syncCampaigns: async (clientCode) => {
      return backend.freespin.syncFirst2Campaigns(clientCode);
    },
    assignPlayers: async (campaignId, payload) => {
      return backend.freespin.assignFirst2Players(campaignId, payload);
    },
    cancelPlayers: async (campaignId, payload) => {
      return backend.freespin.cancelFirst2Players(campaignId, payload);
    },
    getBonusDetails: async (payload) => {
      return backend.freespin.getFirst2BonusDetails(payload);
    },
    getBonusDebit: async (bonusId, customerCode, clientCode) => {
      return backend.freespin.getFirst2BonusDebit(bonusId, customerCode, clientCode);
    },
    getBonusFree: async (bonusId, customerCode, clientCode) => {
      return backend.freespin.getFirst2BonusFree(bonusId, customerCode, clientCode);
    },
    selectCampaign: async (campaignId) => {
      return backend.freespin.selectFirst2Campaign(campaignId);
    },
    unselectCampaign: async (campaignId) => {
      return backend.freespin.unselectFirst2Campaign(campaignId);
    },
  };

  function openPlayersCampaign(row) {
    playersCampaign = row;
    showPlayersCampaign = true;
  }

  async function handlePlayersUpdated(e) {
    const { campaignId } = e.detail || {};
    const updated = await listRef?.refresh?.(campaignId);
    if (updated && playersCampaign?.campaignId === campaignId) {
      playersCampaign = updated;
    }
  }
</script>

<ListCampaignV2
  bind:this={listRef}
  provider={adapter.providerCode}
  {api}
  {icons}
  on:openplayers={(e) => openPlayersCampaign(e.detail)}
/>

{#if showPlayersCampaign}
  <PlayersCampaignV2
    campaign={playersCampaign}
    {api}
    on:close={() => (showPlayersCampaign = false)}
    on:playersUpdated={handlePlayersUpdated}
  />
{/if}
